import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction.ts";
import { FluentProvider } from "@/dependencies";
import { makeStyles, mergeClasses, Switch, SwitchProps } from "@fluentui/react-components";

interface SwitchCustomProps {
  rcName?: string;
  theme?: string;
  rcRole?: string[];
  requireRoles?: string[];
}

const useStyles = makeStyles({
  root: {
    fontWeight: 600,
  },
  disabled: {
    "& label": {
      color: "var(--colorNeutralForeground1) !important",
    },
  },
});

const SwitchCustom = (props: SwitchCustomProps & SwitchProps) => {
  const styles = useStyles();
  const isCanBeVisible = isVisibleComponetBaseOnRole(
    props.rcRole,
    props.requireRoles,
  );

  const isDisabled = props.disabled || !isCanBeVisible;
  return props.theme ? (
    <FluentProvider theme={props.theme}>
      <Switch
        {...props}
        disabled={isDisabled}
        className={mergeClasses(styles.root, isDisabled && styles.disabled, props.className)}
      />
    </FluentProvider>
  ) : (
    <Switch
      {...props}
      disabled={isDisabled}
      className={mergeClasses(styles.root, isDisabled && styles.disabled, props.className)}
    />
  );
};

export default SwitchCustom;
